export default __webpack_public_path__ + "static/media/rnr-sports-table-10-cn.b9e5c000.webp";